import { useState, useCallback } from "react";

/**
 * Toast notification hook
 * Provides a clean API for showing toast messages
 */
export function useToast() {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((type, message, duration = 4000) => {
    setToast({ type, message, duration });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  // Convenience methods
  const success = useCallback((message, duration) => {
    showToast("success", message, duration);
  }, [showToast]);

  const error = useCallback((message, duration) => {
    showToast("error", message, duration);
  }, [showToast]);

  const warning = useCallback((message, duration) => {
    showToast("warning", message, duration);
  }, [showToast]);

  const info = useCallback((message, duration) => {
    showToast("info", message, duration);
  }, [showToast]);

  return {
    toast,
    showToast,
    hideToast,
    success,
    error,
    warning,
    info,
  };
}
